<div class="radio-group-wrapper">
  @if (title()) {
    <h4 class="radio-group-title">{{ title() }}</h4>
  }
  <nz-radio-group [(ngModel)]="value" (ngModelChange)="onValueChange($event)" [nzDisabled]="disabled()">
    @for (option of options(); track option.value) {
      <label 
        nz-radio 
        [nzValue]="option.value"
      >
        @if (option.labelHtml) {
          <span [innerHTML]="option.labelHtml"></span>
        } @else {
          {{ option.label }}
        }
      </label>
    }
  </nz-radio-group>
</div>
